import React, { useState, useEffect } from "react";
import MobileLayout from "../MobileLayout";
import { AppBar, Box, Button, makeStyles, Toolbar, Typography } from "@material-ui/core";
import BackIcon from "@material-ui/icons/ArrowBack";
import { useNavigate, useLocation } from "react-router-dom";
import Carousel from "react-material-ui-carousel";
import breeferPlayButton from "../asset/icons/breeferPlayButton.png";
import Logo from "../asset/logo/LOGO_ORANGE.svg";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { useMediaQuery } from "@material-ui/core";
import "../App.css";
import analytics from "../analytics/track";
import { useBreefDetails } from "./gameService";

// Practice rounds a participant may take before the real game (each is short and doesn't count)
export const MAX_PRACTICE_ROUNDS = 2;
export const practiceRoundsTaken = () => Number(sessionStorage.getItem("practiceRounds") || 0);

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
    backgroundColor: "transparent",
    boxShadow: "none",
  },
}));
const StartAGame = () => {
  const isMobile = useMediaQuery("(max-height:650px)");
  const isTablet = useMediaQuery("(max-height:1024px)");
  const classes = useStyles();
  const [t, i18n] = useTranslation("global");
  const navigate = useNavigate();
  const [isTracked, setIsTracked] = useState(false);
  const userId: any = sessionStorage.getItem("InvitedUserId");

  const storeBreef = useSelector((state: RootState) => state.score.breefDetails);
  // After a reload the store is empty - fetched again
  const breefDetails = useBreefDetails() || storeBreef;
  const game = breefDetails?.gameId;
  const practiceSeconds = game?.practiceSeconds ?? 10;
  const canPractice = practiceSeconds > 0 && practiceRoundsTaken() < MAX_PRACTICE_ROUNDS;

  useEffect(() => {
    if (!isTracked) {
      analytics.track("Game Intro Viewed", {
        breef_id: breefDetails?.id,
        tenant_id: breefDetails?.tenantId.id,
        user_id: userId,
        number_of_qustions: breefDetails?.questions.length,
        start_date: breefDetails?.period,
        expiry_date: breefDetails?.expiry,
        video_url: breefDetails?.videoUrl,
        current_page: "game-info",
        game_name: breefDetails?.gameId.gameName,
      });
      setIsTracked(true);
    }
  }, [isTracked]);

  const handleNext = () => {
    sessionStorage.removeItem("scoreUpdated");
    // if (index < textArray.length - 1) {
    //   setIndex(index + 1);
    // } else {
    //   console.log('End reached');
    // navigate('/game-scene', { state: { totalQuestions: location.state.totalQuestions , score: location.state.score , breefDetails,duration } }); // Access location state
    navigate("/game-scene");
    // }
  };

  return (
    <MobileLayout>
      <AppBar position="static" className={classes.appBar}>
        <Toolbar>{/* <img src={Logo} alt="logo" height="80 rem" /> */}</Toolbar>
      </AppBar>
      {/* <Box display="flex" justifyContent="flex-start" alignItems="center" mt={"3%"}>
        <Button variant="text" startIcon={<BackIcon />} style={{ marginLeft: '3%', marginTop: '3%', textTransform: 'none' }} onClick={() => navigate('/video')}>
          Video
        </Button>
      </Box> */}
      {/* One screen: the play button sits at the bottom, and what is above it gets the rest of the room.
          On a small phone the text scrolls inside its own space rather than pushing the button off screen. */}
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        width="100%"
        className="container"
        style={{ height: "calc(100dvh - 4.5rem)", justifyContent: "space-between" }}
      >
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="flex-start" style={{ flex: 1, minHeight: 0, overflowY: "auto", width: "100%" }}>
          <Box style={{ marginTop: isMobile ? "4%" : "12%", width: "100%" }}>
            <Typography
              variant="h3"
              style={
                isMobile
                  ? { marginLeft: "15%", marginRight: "12%", fontWeight: "350", fontSize: "1.8rem" }
                  : { marginLeft: "15%", marginRight: "12%", fontWeight: "350" }
              }
              align="left"
            >
              {t("gameDesc.desc1")}
              <span
                onClick={() => {
                  handleNext();
                  analytics.track("Game Intro next button clicked", {
                    breef_id: breefDetails?.id,
                    tenant_id: breefDetails?.tenantId.id,
                    user_id: userId,
                    number_of_qustions: breefDetails?.questions.length,
                    start_date: breefDetails?.period,
                    expiry_date: breefDetails?.expiry,
                    video_url: breefDetails?.videoUrl,
                    current_page: "game-info",
                    game_name: breefDetails?.gameId.gameName,
                  });
                }}
                style={{ color: "#EB6608", fontWeight: "bold", cursor: "pointer", fontFamily:"Roboto" }}
              >
                {t("gameDesc.desc2")}
              </span>
              {t("gameDesc.desc3")} {breefDetails?.gameId?.gameDescription}
            </Typography>
            {/* How to play (admin → Spil) - so nobody meets the game unprepared */}
            {(game?.thumbnailUrl || game?.instructions) && (
              <Box style={{ margin: "6% 12% 0 15%", display: "flex", alignItems: "center", gap: "1rem" }}>
                {game?.thumbnailUrl && <img src={game.thumbnailUrl} alt="" style={{ width: "72px", height: "72px", objectFit: "cover", borderRadius: "12px" }} />}
                {game?.instructions && <Typography style={{ fontFamily: "Roboto", fontSize: "1.1rem", whiteSpace: "pre-line" }}>{game.instructions}</Typography>}
              </Box>
            )}
            {canPractice && (
              // The practice round is the side road: plain orange text, like the other links in the app, so the
              // screen keeps the look it had before the practice round existed.
              <Box style={{ marginTop: "8%", width: "100%", textAlign: "center" }}>
                <Button
                  variant="text"
                  disableRipple
                  style={{
                    color: "#EB6608",
                    backgroundColor: "transparent",
                    textTransform: "none",
                    fontFamily: "Roboto",
                    fontWeight: "bold",
                    fontSize: "1.05rem",
                    padding: "0.1rem 0.5rem",
                    minWidth: 0,
                  }}
                  onClick={() => {
                    analytics.track("Game practice clicked", { current_page: "game-info", game_name: game?.gameName });
                    navigate("/game-practice");
                  }}
                >
                  {t("gamePlay.tryGame")}
                </Button>
                <Typography style={{ fontFamily: "Roboto", fontSize: "0.85rem", color: "#666" }}>
                  {t("gamePlay.tryHint")}
                </Typography>
              </Box>
            )}
          </Box>
        </Box>

        {/* The button that starts the real game. The Breefer mark on its own didn't say what it does, so it
            is spelled out underneath. */}
        <Box style={{ flexShrink: 0, padding: "1rem 0 1.5rem", textAlign: "center" }}>
          {/* <Button variant="contained" style={{ backgroundColor: '#EB6608', color: '#FFFFFF', width: '100%' }} onClick={handleNext}>
          {index < textArray.length - 1 ? 'Next' : 'Play'}
        </Button> */}
          <div
            style={{ border: "none" }}
            onClick={() => {
              handleNext();
              analytics.track("Game Intro next button clicked", {
                breef_id: breefDetails?.id,
                tenant_id: breefDetails?.tenantId.id,
                user_id: userId,
                number_of_qustions: breefDetails?.questions.length,
                start_date: breefDetails?.period,
                expiry_date: breefDetails?.expiry,
                video_url: breefDetails?.videoUrl,
                current_page: "game-info",
                game_name: breefDetails?.gameId.gameName,
              });
            }}
          >
            <img src={breeferPlayButton} alt={t("gamePlay.playNow")} style={{ cursor: "pointer", border: "none", height: isMobile ? "56px" : "65px" }} />
            <Typography style={{ fontFamily: "Roboto", fontWeight: 700, color: "#EB6608", fontSize: "1.1rem", marginTop: "0.3rem" }}>
              {t("gamePlay.playNow")}
            </Typography>
            <Typography style={{ fontFamily: "Roboto", fontSize: "0.85rem", color: "#666" }}>{t("gamePlay.playNowHint")}</Typography>
          </div>
        </Box>
      </Box>
    </MobileLayout>
  );
};

export default StartAGame;
